import * as actionTypes from "../actionTypes";

export const setProfile = (profile: actionTypes.profile) => {
    return {
        type: actionTypes.SET_PROFILE,
        payload: profile
    }
}

export const clearProfile = () => {
    return {
        type: actionTypes.CLEAR_PROFILE
    }
}